import { takeEvery, call, put } from 'redux-saga/effects';
import {
  USER_LOGIN_R,
  USER_LOGIN_S,
  USER_LOGIN_F,
  USER_LOGOUT_R,
  USER_LOGOUT_S,
  RESTORE_USER_BY_TOKEN_R,
  RESTORE_USER_BY_TOKEN_S,
  RESTORE_USER_BY_TOKEN_F,
  USERS_R,
  USERS_S,
  USERS_F,
  ROLES_R,
  ROLES_S,
  ROLES_F,
  UPDATE_ROLES_R,
  UPDATE_ROLES_S,
  UPDATE_ROLES_F
} from 'constants/actionTypes';
import * as config from 'services/config';
import * as API from 'services/api';
import { ROUTER_PATHS } from 'routes/routerConstants';
import { LOCAL_STORAGE_ITEMS } from 'constants/constants';

export function* login(action) {
  try {
    const { code } = action.payload;

    const data = {
      code
    };

    const token = yield call(
      API.postLoginData,
      `${config.host}/user/login/cognito/callback`,
      data
    );

    localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN, token.access_token);

    yield put({
      type: USER_LOGIN_S
    });

    yield put({
      type: RESTORE_USER_BY_TOKEN_R
    });
  } catch (error) {
    console.error('Failed to login', error);

    yield put({
      type: USER_LOGIN_F,
      payload: {
        errorMessage: error.message
      }
    });

    config.history.push(ROUTER_PATHS.LOGIN);
  }
}

export function* logout() {
  localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
  localStorage.removeItem(LOCAL_STORAGE_ITEMS.USER_PERMISSIONS);

  yield put({
    type: USER_LOGOUT_S
  });

  config.history.push(ROUTER_PATHS.LOGIN);
}

export function* restoreUserByToken(action) {
  try {
    const token = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
    const user = yield call(API.getData, `${config.host}/user/me`);
    if (user) {
      const next = action.payload
        ? action.payload.next
        : ROUTER_PATHS.RESOURCES;
      localStorage.setItem(
        LOCAL_STORAGE_ITEMS.USER_PERMISSIONS,
        JSON.stringify(user.permissions)
      );
      yield put({
        type: RESTORE_USER_BY_TOKEN_S,
        payload: {
          token,
          user,
          next
        }
      });

      config.history.push(`${next}`);
    }
  } catch (error) {
    console.error('Failed to restore user by token', error);

    yield put({
      type: RESTORE_USER_BY_TOKEN_F
    });
  }
}

export function* users() {
  try {
    const { data } = yield call(API.getData, `${config.host}/user`);
    yield put({
      type: USERS_S,
      payload: {
        data
      }
    });
  } catch (error) {
    console.error(error);
    yield put({
      type: USERS_F
    });
  }
}

export function* roles() {
  try {
    const { data } = yield call(API.getData, `${config.host}/role`);
    yield put({
      type: ROLES_S,
      payload: {
        data
      }
    });
  } catch (error) {
    console.error(error);
    yield put({
      type: ROLES_F
    });
  }
}

export function* updateRoles(action) {
  try {
    const { value, recordKey } = action.payload;
    yield call(API.postData, `${config.host}/role`, {
      key: recordKey,
      value
    });
    yield put({
      type: UPDATE_ROLES_S
    });
  } catch (error) {
    console.error(error);
    yield put({
      type: UPDATE_ROLES_F
    });
  }
}

export const userSagas = [
  takeEvery(ROLES_R, roles),
  takeEvery(UPDATE_ROLES_R, updateRoles),
  takeEvery(USERS_R, users),
  takeEvery(USER_LOGIN_R, login),
  takeEvery(RESTORE_USER_BY_TOKEN_R, restoreUserByToken),
  takeEvery(USER_LOGOUT_R, logout)
];
